import React from 'react';
import {
  MIN_SCORE_OPTIONS,
  MAX_SCORE_OPTIONS,
  VARIANT_OPTIONS,
  BAG_PRESETS,
  bagPresetId,
} from '../utils/spadesSettingsForm';

function SpadesSettingsFields({
  settings,
  onChange,
  disabled = false,
  className = 'spades-host-settings',
  idPrefix = 'spades',
}) {
  const spades = settings || {};
  const currentBagId = bagPresetId(spades);

  const update = (patch) => {
    if (disabled || !onChange) return;
    onChange({ ...spades, ...patch });
  };

  return (
    <div className={className}>
      <label className="spades-host-setting" htmlFor={`${idPrefix}-min`}>
        <span>Min score (set)</span>
        <select
          id={`${idPrefix}-min`}
          value={spades.autoLossAt ?? 0}
          disabled={disabled}
          onChange={(e) => {
            const autoLossAt = Number(e.target.value);
            update({ autoLossAt, minScore: autoLossAt });
          }}
        >
          {MIN_SCORE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </label>

      <label className="spades-host-setting" htmlFor={`${idPrefix}-max`}>
        <span>Max / win</span>
        <select
          id={`${idPrefix}-max`}
          value={spades.winAt ?? 500}
          disabled={disabled}
          onChange={(e) => {
            const winAt = Number(e.target.value);
            update({ winAt, maxScore: winAt });
          }}
        >
          {MAX_SCORE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </label>

      <label className="spades-host-setting" htmlFor={`${idPrefix}-variant`}>
        <span>Variant</span>
        <select
          id={`${idPrefix}-variant`}
          value={spades.scoringMode || 'teams'}
          disabled={disabled}
          onChange={(e) => update({ scoringMode: e.target.value })}
        >
          {VARIANT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </label>

      <label className="spades-host-setting" htmlFor={`${idPrefix}-bags`}>
        <span>Bag penalty</span>
        <select
          id={`${idPrefix}-bags`}
          value={currentBagId}
          disabled={disabled}
          onChange={(e) => {
            const preset = BAG_PRESETS.find((p) => p.id === e.target.value);
            if (preset) {
              update({ bagLimit: preset.bagLimit, bagPenalty: preset.bagPenalty });
            }
          }}
        >
          {BAG_PRESETS.map((p) => (
            <option key={p.id} value={p.id}>{p.label}</option>
          ))}
        </select>
      </label>

      <label className="spades-host-setting spades-host-setting--check">
        <input
          type="checkbox"
          checked={!!spades.doubleNilEnabled}
          disabled={disabled}
          onChange={(e) => update({ doubleNilEnabled: e.target.checked })}
        />
        <span>Enable double nil</span>
      </label>
    </div>
  );
}

export default SpadesSettingsFields;